var _defs, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.88136,
    y: 234.30508,
    width: 724.61017,
    height: 624.81356,
    id: "rect222"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text220",
    style: {
      fontSize: 192,
      lineHeight: 1.25,
      fontFamily: "Arial",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#rect222)"
    },
    transform: "matrix(7.618875,0,0,7.1915302,-1144.07,-2047.597)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 164.88086,
    y: 407.24954,
    id: "tspan283"
  }, "\u0259"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpa);
export default __webpack_public_path__ + "static/media/ipa.f1ae08608abc099a90413a7fca83bdbe.svg";
export { ForwardRef as ReactComponent };